// extracted by mini-css-extract-plugin
export default {"checkbox":"FormCheckbox_checkbox__ix--o","input":"FormCheckbox_input__aENDD","box":"FormCheckbox_box__azAr4"};